import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncsService } from '../services/funcs.service';
import { AccountInfoService } from '../services/account.service';
import { Customer, CustomerCurrent } from '../data/customer';
import { Account, Accounts } from '../data/account-info';
import { Country } from '../data/country';
import { State } from '../data/state';
import { Dealer, DealerCurrent } from '../data/dealer';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrl: './account-info.component.css',
  standalone: false
})
export class AccountInfoComponent {

  errormsg: string = "";
  msg: string = "";

  countriesList: Country[] = [];
  selectedCountry = "";

  stateList: State[] = [];
  selectedState = "";

  account: Partial<Account> = {};

  dealer: Dealer = DealerCurrent;
  ref: any;
  fleet: boolean = false;
  dlr: boolean = false;
  international: boolean = false;
  admin: boolean = false;

  tempRole: any = "";

  constructor(
    private funcs: FuncsService,
    private route: ActivatedRoute,
    private accountInfoService: AccountInfoService
  ) { }

  ngOnInit(): void {
    this.msg = "";
    this.errormsg = "";

    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      } else if (this.ref == "dealer") {
        this.dlr = true;
      } else if(this.ref == "international") {
        this.international = true;
      }
    });

    let username = "";
    if (this.fleet || this.dlr || this.international) {
      this.funcs.currentDealer(this.dealer);      
      username = this.getUsername(this.dealer.pa_code);
    } else {
      this.funcs.checkAdmin();
      this.funcs.currentCustomer(CustomerCurrent);
      username = CustomerCurrent.username;
    }

    this.admin = this.funcs.isAdmin();
    
    // if (CustomerCurrent.authenticated === "Y" && this.funcs.isAdminRole(CustomerCurrent.role)) {
    //   this.tempRole = "admin";
    // } else {
      this.tempRole = "not";
    // }

    this.getAccountInfo(username);
    this.getCountries(this.tempRole);
    this.getStates();
  }

  getUsername(pa_code: string): string {
    var country = this.funcs.getThreeLetterCountry(pa_code);
    if (country == "USA" || country == "CAN") {
      pa_code = pa_code.slice(3);
    }
    var username = "";
    if (this.fleet) {
      username = `FIN${pa_code}`;
    } else if (this.dlr || this.international) {
      username = `FCT${pa_code}`;
    }

    return username;
  }

  uname: string | undefined;
  getAccountInfo(username: string) {
    this.accountInfoService.getAccountInfo(username).subscribe(account => {
      this.account = account;
      this.selectedState = this.account.state || "";
      this.selectedCountry = this.account.country || "";
      if (this.account.billingEmail == "") {
        this.account.billingEmail = this.account.email;
      }
      if(this.account.billingDate != null) {
        this.account.billingDate = formatDate(this.account.billingDate, 'yyyy-MM-dd', 'en-US');
      }
      if(this.international) {
        this.uname = this.account.username?.replace('FCT', '');
      }
    });
  }

  getCountries(tempRole: string) {
    this.accountInfoService.getCountries(tempRole).subscribe(countries => {
      countries.forEach(ct => {
        this.countriesList.push({ countryName: ct.countryName, countryCode: ct.countryCode, countryCode3: ct.countryCode3, retailRestricted: ct.retailRestricted });
      });
    });
  }

  getStates() {
    this.accountInfoService.getStates().subscribe(states => {
      this.stateList.push({ countryCode: 'NA', stateCode: 'NA', stateName: 'Not Applicable' });
      states.forEach(st => {
        this.stateList.push({ countryCode: st.countryCode, stateCode: st.stateCode, stateName: st.stateName });
      });
    });
  }

  statesChanged(value: string) {
    this.stateList.forEach(st => {
      if (st.stateCode == value) {
        this.selectedCountry = st.countryCode;
      }
    });
  }

  countriesChanged(value: string) {
    if (this.selectedCountry != "US" && this.selectedCountry != "CA") {
      this.selectedState = "NA";
    }
    if ((this.selectedState === "" || this.selectedState === "NA") && (this.selectedCountry == "US" || this.selectedCountry == "CA")) {
      this.selectedState = "";
    }
  }

  updateAccount() {
    this.msg = "";
    this.errormsg = "";

    if (!this.international && (this.selectedState === "" || this.selectedState === "NA")) {
      this.errormsg = "Select State";
      return;
    } 
    if (this.international && this.account.state == "") {
      this.errormsg = "Provide State";
      return;
    }
    if (this.selectedCountry === "") {
      this.errormsg = "Select Country";
      return;
    }

    if(!this.international) {
      this.account.state = this.selectedState;
    } 
    this.account.country = this.selectedCountry;

    const account = this.account as Account;

    this.accountInfoService.updateAccount(account, CustomerCurrent.username).subscribe(result => {      
      if (result) {
        this.msg = "Update applied successfully.";
      } else {
        this.errormsg = "Update Failed.";
      }
    });

  }
}
